/** English of the interface (ADR 0069), keyed by the exact French phrase. See `index.ts`. */
export const QUESTS: Readonly<Record<string, string>> = {
  // ui/achievement-text.ts
  'Succès accompli : {name}.': 'Achievement unlocked: {name}.',
  'Succès accompli : {name}. Nouveau titre : {title}.':
    'Achievement unlocked: {name}. New title: {title}.',
  'Demande invalide.': 'Invalid request.',
  'Ce succès n’existe pas.': 'This achievement doesn’t exist.',
  'Ce succès ne donne pas d’objet.': 'This achievement gives no item.',
  'Ce succès n’est pas encore accompli.': 'This achievement isn’t done yet.',
  'Récompense déjà récupérée.': 'Reward already claimed.',
  'Ce titre n’est pas encore gagné.': 'You haven’t earned this title yet.',
  'Ton sac est plein : fais de la place pour récupérer la récompense.':
    'Your Bag is full: make room to claim the reward.',

  // ui/achievement-toast.ts
  'Succès accompli': 'Achievement unlocked',
  'Nouveau titre : {title}': 'New title: {title}',
  'Nouveau sort': 'New Spell',
  'Place-le dans ta barre depuis le grimoire': 'Put it on your bar from the Spellbook',

  // ui/achievements-tab.ts
  Exploits: 'Feats',
  'Titre porté': 'Title worn',
  '{count} obtenus': '{count} earned',
  Aucun: 'None',
  'Termine une région ou un exploit pour gagner un titre.':
    'Complete a region or a feat to earn a title.',
  'Récompense : titre « {title} »': 'Reward: title “{title}”',
  'Titre : {title}': 'Title: {title}',
  '{name} : récupérée': '{name}: claimed',
  'Récupérer : {name}': 'Claim: {name}',

  // ui/contract-text.ts
  'Ce contrat n’existe pas.': 'This Contract doesn’t exist.',
  'Ce contrat n’est pas encore rempli.': 'This Contract isn’t done yet.',
  'Tu as déjà touché ce contrat.': 'You’ve already cashed in this Contract.',
  'Ton sac est plein : fais-y de la place pour la récompense.':
    'Your Bag is full: make room for the reward.',
  'Un instant…': 'One moment…',
  'Les leçons du camp ne s’abandonnent pas.': 'The camp’s lessons can’t be abandoned.',
  'Contrat touché, mais ton sac est trop plein pour la récompense de série : fais de la place, elle viendra au prochain contrat.':
    'Contract cashed in, but your Bag is too full for the Streak reward: make room, it will come with your next Contract.',
  'Chasse : {count} × {mob}': 'Hunt: {count} × {mob}',
  'Abats {count} créatures ({region})': 'Slay {count} creatures ({region})',
  'Nettoie un camp ({region})': 'Clear a Camp ({region})',
  'Tente {count} améliorations chez le forgeron': 'Try {count} Upgrades at the Blacksmith',
  'Ramasse {count} objets': 'Pick up {count} items',
  'Lance {count} sorts': 'Cast {count} Spells',
  'Vaincs {count} boss de zone différents': 'Defeat {count} different zone Bosses',
  'Vaincs un boss de zone': 'Defeat a zone Boss',
  'Remplis {count} contrats du jour': 'Complete {count} daily Contracts',
  'Gagne {count} événements mondiaux': 'Win {count} world events',
  '{gold} or': '{gold} gold',
  '{days} j {hours} h': '{days} d {hours} h',
  '{hours} h {minutes}': '{hours} h {minutes}',
  '{minutes} min': '{minutes} min',

  // ui/contract-board.ts
  'Les contrats arrivent…': 'Contracts on their way…',
  'Contrats du jour': 'Daily Contracts',
  'Contrat de la semaine': 'Weekly Contract',
  ' · nouveaux dans {time}': ' · new in {time}',
  'Série de connexions': 'Login Streak',
  ' · {days} jours': ' · {days} days',
  ' · {days} jour': ' · {days} day',
  'Aujourd’hui est compté. Demain : {reward}.': 'Today counts. Tomorrow: {reward}.',
  'Remplis un contrat du jour pour compter aujourd’hui : {reward}.':
    'Complete a daily Contract to count today: {reward}.',
  'Encore {left} jours de série pour l’adopter ({days}/{goal}).':
    '{left} more Streak days to adopt it ({days}/{goal}).',
  'Encore {left} jour de série pour l’adopter ({days}/{goal}).':
    '{left} more Streak day to adopt it ({days}/{goal}).',
  'Adopté : équipe-le comme familier depuis ton sac.': 'Adopted: equip it as a Pet from your Bag.',
  'Butin des boss': 'Boss Loot',
  'Butin du jour encore à prendre : {bosses}.': 'Loot of the day still to take: {bosses}.',
  'Tous les boss ont donné leur butin aujourd’hui.': 'Every Boss has given its Loot today.',
  Touché: 'Cashed in',
  Encaisser: 'Cash in',

  // ui/quest-text.ts
  'Cette quête n’existe pas.': 'This Quest doesn’t exist.',
  'Approche-toi pour lui parler.': 'Come closer to talk to them.',
  'Ce n’est pas à cette personne qu’il faut s’adresser.': 'This isn’t the person to talk to.',
  'Tu as déjà accompli cette quête.': 'You’ve already completed this Quest.',
  'Cette quête est déjà dans ton journal.': 'This Quest is already in your Journal.',
  'Il faut d’abord accomplir la quête précédente.': 'Complete the previous Quest first.',
  'Ton niveau est trop bas pour cette quête.': 'Your Level is too low for this Quest.',
  'Ton journal est plein : abandonne une quête d’abord.':
    'Your Journal is full: abandon a Quest first.',
  'Cette quête n’est pas dans ton journal.': 'This Quest isn’t in your Journal.',
  'Tu n’as pas encore tout fait.': 'You haven’t done everything yet.',
  'La forêt murmure, et je l’écoute. Reviens me voir bientôt : j’aurai du travail pour toi.':
    'The forest whispers, and I listen. Come back soon: I’ll have work for you.',
  'Bonne route, voyageur.': 'Safe travels, traveler.',
  '{objective} {value}/{target}': '{objective} {value}/{target}',
  '{xp} XP': '{xp} XP',
  'Enseigne le sort : {spell}': 'Teaches the Spell: {spell}',

  // ui/quest-rewards.ts
  'Remis avec la quête': 'Given with the Quest',
  Récompense: 'Reward',

  // ui/quest-client.ts
  'Quête accomplie': 'Quest completed',
  'Quête accomplie : {quest}. {reward}': 'Quest completed: {quest}. {reward}',
  'Contrat rempli': 'Contract done',
  'Encaisse-le dans le journal ({key}), onglet Contrats.':
    'Cash it in from the Journal ({key}), Contracts tab.',
  'Contrat rempli : {contract}.': 'Contract done: {contract}.',
  'Butin du jour': 'Loot of the day',
  'Ton butin t’attend près de lui.': 'Your Loot awaits you by it.',
  '{boss} : ton butin du jour est tombé !': '{boss}: your Loot of the day has dropped!',
  'Série : jour {days}': 'Streak: day {days}',
  'Renard de lumière': 'Light Fox',
  'Récompense de série': 'Streak reward',
  'Il t’attend dans ton sac : équipe-le comme familier.':
    'It’s waiting in your Bag: equip it as a Pet.',
  'Série de connexions, jour {days} : {reward}.': 'Login Streak, day {days}: {reward}.',
  'Contrat encaissé : {reward}.': 'Contract cashed in: {reward}.',
  'Un {mob} sort du terrier, attiré par l’odeur !':
    'A {mob} comes out of the burrow, drawn by the smell!',
  'Nouvelle quête': 'New Quest',
  'Nouvelle quête : {quest}.': 'New Quest: {quest}.',
  'Quête terminée': 'Quest done',
  'Retourne voir {npc}.': 'Go back to {npc}.',
  'Objectif accompli : {objective}.': 'Objective done: {objective}.',

  // ui/quest-dialog.ts
  'Fermer (Échap)': 'Close (Esc)',
  'Rendre la quête': 'Turn in Quest',
  Accepter: 'Accept',
  'Reviens me voir au niveau {level} : c’est encore trop dangereux pour toi.':
    'Come back to me at Level {level}: it’s still too dangerous for you.',

  // ui/quest-journal.ts
  'Retour à la liste': 'Back to the list',
  'Journal de quêtes': 'Quest Journal',
  Quêtes: 'Quests',
  Contrats: 'Contracts',
  'Contrats ({count})': 'Contracts ({count})',
  'Aucune quête en cours. Cherche le « ! » doré au-dessus des habitants.':
    'No Quest under way. Look for the golden “!” above the townsfolk.',
  'Accomplies ({count})': 'Completed ({count})',
  'À rendre': 'Turn in',
  '{region} · niveau {level}': '{region} · Level {level}',
  'Terminée : retourne voir {npc}.': 'Done: go back to {npc}.',
  'À rendre à {npc} une fois terminée.': 'Turn in to {npc} once done.',
  'Quête accomplie.': 'Quest completed.',
  'Confirmer l’abandon': 'Confirm abandon',
  Abandonner: 'Abandon',

  // ui/quest-tracker.ts
  'Quêtes en cours': 'Quests under way',
  'Quêtes ({count})': 'Quests ({count})',
  'Retourne voir {npc}': 'Go back to {npc}',
  'et {count} autre(s)…': 'and {count} more…',

  // ui/travel-panel.ts
  'Ce portail n’existe pas.': 'This Portal doesn’t exist.',
  'Tu dois d’abord utiliser ce portail sur place.': 'You must first use this Portal in person.',
  'Tu es déjà à ce portail.': 'You’re already at this Portal.',
  'Il te manque de l’or.': 'You don’t have enough gold.',
  'Approche-toi du portail.': 'Come closer to the Portal.',
  'Pas tant que tu es à terre.': 'Not while you’re down.',
  'Tu es en plein combat.': 'You’re in the middle of a fight.',
  Portails: 'Portals',
  '{refusal} Attends encore {seconds} s.': '{refusal} Wait {seconds} more s.',
  'En plein combat : voyage possible dans {seconds} s.':
    'In combat: Travel possible in {seconds} s.',
  'Loin de tout portail.': 'Far from any Portal.',
  'Au portail de {place}.': 'At the {place} Portal.',
  'Tu te relèves au sanctuaire de la capitale.': 'You get back up at the capital’s sanctuary.',
  'Tu te relèves à {place}.': 'You get back up at {place}.',
  'Bourse : {gold} or.': 'Purse: {gold} gold.',
  '{region}, {levels}': '{region}, {levels}',
  Réapparition: 'Respawn',
  'Réapparaître ici': 'Respawn here',
  'Voyager, {cost} or': 'Travel, {cost} gold',
  'Portail à découvrir': 'Portal to discover',

  // ui/camp-coach.ts
  'Touche le sol pour marcher, touche une créature pour l’attaquer.':
    'Tap the ground to walk, tap a creature to attack it.',
  'Clic ou {keys} : marcher': 'Click or {keys}: walk',
  '{key} : cibler et attaquer': '{key}: target and attack',
  '{key} : changer de cible': '{key}: switch target',
  'Clic sur un butin : ramasser': 'Click loot: pick it up',
  Commandes: 'Controls',
  'Masquer les commandes': 'Hide the controls',

  // ui/camp-coach-steps.ts
  'Ouvre ton sac pour enfiler ce que tu viens d’obtenir.':
    'Open your bag to put on what you just got.',
  'Touche chaque pièce qui brille dans ton sac, puis « Équiper ».':
    'Tap each glowing piece in your bag, then “Equip”.',
  'Double-clique sur chaque pièce qui brille dans ton sac pour l’enfiler.':
    'Double-click each glowing piece in your bag to put it on.',
  'Accepte la quête de Ser Givrecoeur.': 'Accept Ser Givrecoeur’s quest.',
  'Clique sur Ser Givrecoeur, le chevalier juste à côté de toi.':
    'Click Ser Givrecoeur, the knight right next to you.',
  'Suis la flèche jusqu’aux rats et clique sur un rat pour l’attaquer. Clique ensuite sur ce qu’il laisse pour le ramasser.':
    'Follow the arrow to the rats and click a rat to attack it. Then click what it drops to pick it up.',
  'Rends la quête à Ser Givrecoeur.': 'Turn the quest in to Ser Givrecoeur.',
  'Retourne voir Ser Givrecoeur et clique sur lui.': 'Go back to Ser Givrecoeur and click him.',
  'Accepte la quête d’Odon.': 'Accept Odon’s quest.',
  'Suis la flèche jusqu’à Odon, le marchand, et clique sur lui.':
    'Follow the arrow to Odon, the merchant, and click him.',
  'Rends la quête à Odon.': 'Turn the quest in to Odon.',
  'Retourne voir Odon et clique sur lui.': 'Go back to Odon and click him.',
  'Ouvre les affaires d’Odon.': 'Open Odon’s wares.',
  'Clique sur Odon, le marchand.': 'Click Odon, the merchant.',
  'Vends tes peaux : « Tout » vend la pile entière.':
    'Sell your pelts: “All” sells the whole stack.',
  'Ouvre l’onglet Vendre pour vendre tes peaux.': 'Open the Sell tab to sell your pelts.',
  'Il te manque de l’or : retourne chasser des rats et vends leurs peaux à Odon.':
    'You’re short of gold: hunt more rats and sell their pelts to Odon.',
  'Achète les pièces qui brillent.': 'Buy the glowing pieces.',
  'Ouvre l’onglet Acheter.': 'Open the Buy tab.',
  'Accepte la quête de Garin.': 'Accept Garin’s quest.',
  'Suis la flèche jusqu’à Garin, le fondeur, et clique sur lui.':
    'Follow the arrow to Garin, the smelter, and click him.',
  'Rends la quête à Hald.': 'Turn the quest in to Hald.',
  'Retourne voir Hald, le forgeron, et clique sur lui.':
    'Go back to Hald, the blacksmith, and click him.',
  'Clique sur « Fusionner ».': 'Click “Fuse”.',
  'Ouvre l’atelier de Garin.': 'Open Garin’s workshop.',
  'Clique sur Garin pour fondre tes cinq épées.': 'Click Garin to melt your five swords.',
  'Prends l’épée rare en main.': 'Take the rare sword in hand.',
  'Choisis ton épée rare, puis clique sur « Améliorer ».':
    'Pick your rare sword, then click “Upgrade”.',
  'Ouvre la forge de Hald.': 'Open Hald’s forge.',
  'Suis la flèche jusqu’à Hald, le forgeron, et clique sur lui.':
    'Follow the arrow to Hald, the blacksmith, and click him.',
  'Accepte la lettre de Ser Givrecoeur.': 'Accept Ser Givrecoeur’s letter.',
  'Retourne voir Ser Givrecoeur, il a une lettre pour toi.':
    'Go back to Ser Givrecoeur, he has a letter for you.',
  'Passe l’arche bleue, à l’est, pour rejoindre Havrebourg.':
    'Go through the blue arch, to the east, to reach Havrebourg.',

  // ui/tutor-panel.ts
  'Bienvenue au camp de la Compagnie Givrecoeur, recrue. Moi aussi, j’ai commencé torse nu.':
    'Welcome to the Givrecoeur Company camp, recruit. I started bare-chested too.',
  'Les rats du terrain d’entraînement, au sud-est, laissent des peaux. Ramasse-les toutes : le marchand te les rachète, et avec cet or tu t’équiperas.':
    'The rats on the training ground, to the southeast, drop pelts. Pick them all up: the Merchant buys them, and that gold will pay for your gear.',
  'Le marchand, près de l’étal, rachète ce que tu rapportes de la chasse.':
    'The Merchant, by the stall, buys what you bring back from the hunt.',
  'Vends-lui tes peaux : au camp, c’est ton seul or.':
    'Sell him your pelts: in the camp, they’re your only gold.',
  'Achète-lui les trois pièces qui manquent, et enfile-les avec ses deux cadeaux. C’est modeste, mais chaque pièce que tu portes se voit sur toi.':
    'Buy the three pieces you’re missing from him, and put them on with his two gifts. It’s modest, but every piece you wear shows on you.',
  'Chaque pièce existe en quatre raretés : commune, rare, épique et légendaire. La couleur du contour, dans ton sac, te la dit.':
    'Every piece comes in four rarities: Common, Rare, Epic and Legendary. The color of its outline, in your Bag, tells you which.',
  'Le fondeur fond {count} pièces identiques en une seule de la rareté au-dessus. Il ne prend que ce qui est dans ton sac.':
    'The Smelter melts {count} identical pieces into one of the rarity above. He only takes what’s in your Bag.',
  'Une épée rare, déjà ! Équipe-la, avec tout ce que tu ne portes pas encore.':
    'A Rare sword already! Equip it, along with everything you aren’t wearing yet.',
  'Le forgeron améliore une pièce de +1 à +10, avec les matériaux de sa région et un peu d’or.':
    'The Blacksmith upgrades a piece from +1 to +10, with Materials from his region and a little gold.',
  'Les premiers niveaux réussissent toujours, les derniers presque jamais, mais un échec ne coûte que les matériaux. Mon équipement est à +10 : Hald l’a forgé pour Givrecime, et c’est là que ton chemin mène.':
    'The first levels always succeed, the last almost never, but a failure only costs the Materials. My Equipment is +10: Hald forged it for Givrecime, and that’s where your path leads.',
  'Tu es prêt. L’arche bleue, à l’est, t’emmène à Havrebourg : porte ma lettre au capitaine Aldric.':
    'You’re ready. The blue arch, to the east, takes you to Havrebourg: bring my letter to Captain Aldric.',
  'J’ai vu la glace se fendre sous Givrecime, et une lueur rouge dessous. On ne me croit pas encore. On me croira. Je t’attends au quartier de la Compagnie. Tant que le givre tient.':
    'I saw the ice crack beneath Givrecime, and a red glow below it. No one believes me yet. They will. I’ll wait for you at the Company’s quarter. As long as the frost holds.',
  'Aucun de tes autres personnages n’a quitté le camp : suis les leçons, cette fois.':
    'None of your other Characters has left the camp: follow the lessons this time.',
  'Approche-toi, que je te confie ton équipement.':
    'Come closer, so I can hand you your Equipment.',
  'Ton sac est plein : fais-y de la place.': 'Your Bag is full: make room in it.',
  'Les « ! » dorés au-dessus des habitants du camp marquent une quête à prendre, les « ? » une quête à rendre. Ton journal ({key}) garde le fil.':
    'A golden “!” above the camp’s folk marks a Quest to take, a “?” a Quest to turn in. Your Journal ({key}) keeps track.',
  Commune: 'Common',
  Rare: 'Rare',
  Épique: 'Epic',
  Légendaire: 'Legendary',
  'Au marchand': 'To the Merchant',
  'Au forgeron': 'To the Blacksmith',
  Or: 'Gold',
  'Guerrier · set de givre légendaire, +10': 'Warrior · Legendary frost set, +10',
  'Guerrier · set de givre légendaire, +10 · sur {mount}, son pégase':
    'Warrior · Legendary frost set, +10 · on {mount}, his pegasus',
  'Tu connais déjà le camp : si tu veux, je te confie l’équipement des leçons, épée rare à +1 comprise, et tu pars tout de suite pour Havrebourg.':
    'You already know the camp: if you like, I’ll hand you the lessons’ Equipment, Rare sword at +1 included, and you leave for Havrebourg right away.',
  'Confirmer : partir pour Havrebourg': 'Confirm: leave for Havrebourg',
  'Aller directement à Havrebourg': 'Go straight to Havrebourg',
  'Approche-toi de lui.': 'Come closer to him.',

  // ui/world-event-agenda.ts
  'dans {minutes} min': 'in {minutes} min',
  'dans {hours} h': 'in {hours} h',
  'dans {hours} h {minutes}': 'in {hours} h {minutes}',
  'Prochains événements': 'Upcoming events',
  '{event} à {village}, {hour}': '{event} at {village}, {hour}',
  'niv. {min}-{max}': 'Lv. {min}-{max}',
  '{village} · niv. {min}-{max}': '{village} · Lv. {min}-{max}',

  // ui/world-event-result.ts
  '{place} est sauvé !': '{place} is saved!',
  '{place} est pillé': '{place} is plundered',
  '{event} annulée': '{event} canceled',
  '{event} interrompue': '{event} stopped',
  Fermer: 'Close',
  '+{xp} XP (à tes pieds)': '+{xp} XP (at your feet)',
  '+{xp} XP · {items} (à tes pieds)': '+{xp} XP · {items} (at your feet)',
  'Personne n’est récompensé.': 'No one is rewarded.',
  'Tu n’as pas pris part à la défense.': 'You didn’t take part in the defense.',
  '{rank}e sur {total}, {percent} % des points': '#{rank} of {total}, {percent}% of the points',
  '{place} : récompense gagnée.': '{place}: reward earned.',
  '{place} : pas assez pour la récompense ({threshold} points).':
    '{place}: not enough for the reward ({threshold} points).',

  // ui/world-event-standings.ts
  'niv. {level} · tombé': 'Lv. {level} · fallen',
  'niv. {level}': 'Lv. {level}',
  '{percent} %': '{percent}%',
  '{name} : {score} points': '{name}: {score} points',

  // ui/world-event-tracker.ts
  'Événement mondial': 'World event',
  '{event} · {place}': '{event} · {place}',
  'Les assaillants approchent': 'The attackers are coming',
  '{count} défenseurs': '{count} defenders',
  'Vague {wave}/{waves} · le chef de guerre est là !': 'Wave {wave}/{waves} · the warlord is here!',
  'Vague {wave}/{waves} · {foes} assaillants': 'Wave {wave}/{waves} · {foes} attackers',
  'Classement ({count})': 'Ranking ({count})',
  'Frappe un assaillant pour entrer au classement': 'Hit an attacker to join the ranking',
  'Frappe le géant pour entrer au classement': 'Hit the giant to join the ranking',
  'Reste près du chariot pour entrer au classement': 'Stay near the cart to join the ranking',
  '{count} escorteurs': '{count} escorts',
  '{count} combattants': '{count} fighters',
  'Le chariot va partir': 'The cart is about to leave',
  'Le géant approche': 'The giant is coming',
  'Le géant est là !': 'The giant is here!',
  'Route : {progress} % · le chariot avance': 'Road: {progress}% · the cart is moving',
  'Route : {progress} % · le chariot est arrêté': 'Road: {progress}% · the cart has stopped',
  'Avant le départ': 'Until it leaves',
  'Avant son arrivée': 'Until it arrives',
  'Le géant est tombé !': 'The giant has fallen!',
  'Le géant s’est éloigné': 'The giant wandered off',
  'Le chariot est arrivé à {place} !': 'The cart reached {place}!',
  'Le chariot n’est pas arrivé à temps': 'The cart didn’t arrive in time',
  'Tu n’as pas pris part à l’escorte.': 'You didn’t take part in the escort.',
  'Tu n’as pas pris part au combat.': 'You didn’t take part in the fight.',
  '+{gold} or dans ta bourse': '+{gold} gold in your purse',
  'Tombé : tu ne peux plus aider': 'Fallen: you can’t help anymore',
  'Tombé · récompense acquise': 'Fallen · reward earned',
  'Tombé · hors du combat': 'Fallen · out of the fight',
  'Récompense acquise': 'Reward earned',
  '{points} pts pour la récompense': '{points} pts to the reward',
  'Toi : {rank}e · {percent} %': 'You: #{rank} · {percent}%',
  'Avant l’attaque': 'Before the attack',
  'Temps restant': 'Time left',

  // ui/world-map.ts
  Facile: 'Easy',
  'À ton niveau': 'Your Level',
  Difficile: 'Hard',
  Dangereux: 'Deadly',
  'Carte du monde': 'World Map',
  Toi: 'You',
  Régions: 'Regions',
  Village: 'Village',
  "Lieu d'intérêt": 'Point of interest',
  'Repaire de boss': 'Boss lair',
  Portail: 'Portal',
  Carte: 'Map',
  '[GM] Clic : s’y téléporter': '[GM] Click: teleport there',
  Zoomer: 'Zoom in',
  Dézoomer: 'Zoom out',
  'Me recentrer': 'Back to me',
  Événements: 'Events',
  Légende: 'Key',
  '{region} · {levels}': '{region} · {levels}',
  '{boss} · niv. {level}': '{boss} · Lv. {level}',
  '{levels} · {village}': '{levels} · {village}',
  'Niveau {level} : cap sur {region}.': 'Level {level}: head for {region}.',
  'Niveau {level} : toute la vallée est à toi.': 'Level {level}: the whole valley is yours.',
  'Niveau {level} : reste près de Havrebourg.': 'Level {level}: stay near Havrebourg.',
};
